<div class="document-creator-container">
    <mat-card>
        <mat-card-content>
            <h4 style="margin-bottom: 30px;" class="card-title"><span class="lstick"></span>
                Kreator dokumentów
            </h4>

            <form [formGroup]="form">
                <div class="document-filters">
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Typ dokumentu</mat-label>
                        <mat-select formControlName="type">
                            <mat-option *ngFor="let type of documentTypes" [value]="type.value">
                                {{ type.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Język</mat-label>
                        <mat-select formControlName="language">
                            <mat-option *ngFor="let lang of languages" [value]="lang.name">
                                {{ lang.name }}
                                <span *ngIf="hasUnsavedChanges && confirmedLanguageName === lang.name"
                                    matTooltip="Niezapisane zmiany">*</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div *ngIf="isLoading" class="loading-spinner">
                    <mat-spinner diameter="40"></mat-spinner>
                </div>

                <div *ngIf="!isLoading && currentDocument" class="document-editor">
                    <!-- Zmienne szablonu -->
                    <div class="full-width variables-section" *ngIf="variables.length > 0">
                        <div style="margin-bottom: 15px;">
                            <label style="display: block; margin-bottom: 8px; font-weight: 500;">Wstaw zmienną:</label>

                            <mat-accordion multi="true">
                                <!-- Panel: Wykorzystane zmienne -->
                                <mat-expansion-panel [expanded]="usedCount > 0" *ngIf="usedCount > 0">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <mat-icon style="margin-right: 8px; color: #4caf50;">check_circle</mat-icon>
                                            Wykorzystane
                                            <span matBadge="{{ usedCount }}" matBadgeColor="accent"
                                                matBadgeOverlap="false" style="margin-left: 8px;"></span>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="variables-grid">
                                        <button *ngFor="let variable of usedVariables" mat-stroked-button type="button"
                                            (click)="insertVariable(variable.key)" [matTooltip]="variable.tooltip"
                                            class="variable-button used">
                                            {{ variable.label }}
                                        </button>
                                    </div>
                                </mat-expansion-panel>

                                <!-- Panel: Niewykorzystane zmienne -->
                                <mat-expansion-panel [expanded]="usedCount === 0 || unusedCount > 0">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <mat-icon
                                                style="margin-right: 8px; color: #ff9800;">radio_button_unchecked</mat-icon>
                                            Niewykorzystane
                                            <span matBadge="{{ unusedCount }}" matBadgeColor="warn"
                                                matBadgeOverlap="false" style="margin-left: 8px;"></span>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="variables-grid">
                                        <button *ngFor="let variable of unusedVariables" mat-stroked-button
                                            type="button" (click)="insertVariable(variable.key)"
                                            [matTooltip]="variable.tooltip" class="variable-button unused">
                                            {{ variable.label }}
                                        </button>
                                    </div>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>
                    </div>

                    <!-- Edytor treści -->
                    <label style="display: block; margin-bottom: 10px; font-weight: 500;">
                        Treść dokumentu
                        <span *ngIf="hasUnsavedChanges" style="color: #ff6b6b; margin-left: 5px;">●</span>
                    </label>

                    <div style="display: flex; gap: 10px; margin-bottom: 10px;">
                        <button mat-stroked-button type="button" (click)="toggleHtmlMode()">
                            {{ isHtmlMode ? 'Tryb wizualny' : 'Tryb HTML' }}
                        </button>
                    </div>

                    <editor [apiKey]="apiKey" *ngIf="!isHtmlMode" [init]="tinyMceConfig" [(ngModel)]="model.editorData"
                        (ngModelChange)="onEditorContentChange()" (onInit)="onEditorReady($event)"
                        [ngModelOptions]="{ standalone: true }">
                    </editor>

                    <textarea *ngIf="isHtmlMode" #htmlSourceEditor class="html-source-editor"
                        [(ngModel)]="model.editorData" (ngModelChange)="onEditorContentChange()"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Wklej lub edytuj surowy HTML dokumentu..."></textarea>

                    <!-- Przyciski akcji -->
                    <div style="margin-top: 20px; display: flex; gap: 10px;">
                        <button mat-raised-button color="primary" type="button" (click)="saveDocument()"
                            [disabled]="!form.valid || !model.editorData">
                            <span>Zapisz</span>
                            <span *ngIf="hasUnsavedChanges" style="margin-left: 5px;">●</span>
                        </button>
                        <button mat-stroked-button type="button" (click)="resetForm()" [disabled]="!hasUnsavedChanges"
                            matTooltip="Anuluj niezapisane zmiany">
                            Anuluj
                        </button>
                    </div>
                </div>

                <div *ngIf="!isLoading && !currentDocument && selectedType && selectedLanguage" class="no-document">
                    <p>Brak dokumentu dla wybranego typu i języka.</p>
                    <button mat-raised-button color="primary" type="button" (click)="saveDocument(true)">
                        Utwórz nowy
                    </button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>